
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Mumbaitogoacab() {



    const cardData =
    {
        keyword: 'Mumbai to Goa Cabs',
        heading: 'S9 Travels:  Mumbai to Goa Cabs',
        headingDescription: 'S9 Travels offers Mumbai to Goa Cab Service, providing a comfortable, reliable, and hassle-free journey. Whether you are heading to Goa for a beach vacation, corporate retreat, or adventure trip, our Innova cabs ensure a smooth and enjoyable ride. With spacious interiors, luxury features, and experienced drivers, we guarantee a safe and stress-free travel experience. Enjoy on-time pickups, affordable pricing, and 24/7 service. Book your Mumbai to Goa cab with S9 Travels for a seamless and memorable trip!',


        top: 'Top Places to Visit in Goa with S9 Travels',

"topPlaces": [
    {
      "title": "Baga Beach",
      "description": "One of the most popular beaches in Goa, Baga Beach is known for its lively nightlife, water sports, and beachside shacks offering delicious seafood and drinks."
    },
    {
      "title": "Calangute Beach",
      "description": "The largest beach in North Goa, Calangute is often called the 'Queen of Beaches.' It’s famous for its golden sands, water sports, and bustling markets."
    },
    {
      "title": "Basilica of Bom Jesus",
      "description": "A UNESCO World Heritage Site, this 400-year-old church houses the mortal remains of St. Francis Xavier and is an architectural marvel of Baroque style."
    },
    {
      "title": "Dudhsagar Waterfalls",
      "description": "One of India’s tallest waterfalls, Dudhsagar offers breathtaking views, especially during the monsoon. It is a popular trekking and adventure spot."
    },
    {
      "title": "Fort Aguada",
      "description": "A well-preserved 17th-century Portuguese fort overlooking the Arabian Sea. It also houses a lighthouse and offers stunning views of the coastline."
    },
    {
      "title": "Chapora Fort",
      "description": "Famous for its appearance in the Bollywood movie 'Dil Chahta Hai,' Chapora Fort offers spectacular views of the Vagator Beach and the surrounding landscape."
    },
    {
      "title": "Anjuna Flea Market",
      "description": "A vibrant market held every Wednesday, Anjuna Flea Market is perfect for shopping lovers looking for handmade jewelry, clothes, souvenirs, and more."
    },
    {
      "title": "Palolem Beach",
      "description": "A picturesque beach in South Goa, Palolem is known for its calm waters, scenic beauty, and colorful beach huts. It’s perfect for a relaxing getaway."
    },
    {
      "title": "Se Cathedral",
      "description": "One of the largest churches in Asia, Se Cathedral is known for its stunning Portuguese-Gothic architecture and holds religious significance in Goa."
    },
    {
      "title": "Butterfly Beach",
      "description": "A hidden gem in South Goa, Butterfly Beach is known for its serene atmosphere, golden sands, and occasional sightings of dolphins in the sea."
    }
],

"services": [
    {
      "name": "Mumbai to Goa Cab Service",
      "description": "S9 Travels offers reliable and comfortable cab services from Mumbai to Goa. Whether you're traveling for leisure or business, our cabs ensure a smooth and enjoyable ride to one of India's most popular destinations."
    },
    {
      "name": "Book Mumbai to Goa Taxi",
      "description": "Booking a taxi from Mumbai to Goa with S9 Travels is quick and easy. Choose from one-way or round-trip options and enjoy a hassle-free journey with professional drivers who ensure comfort and safety."
    },
    {
      "name": "Mumbai to Goa One-Way Cab",
      "description": "Planning a one-way trip from Mumbai to Goa? S9 Travels offers affordable and comfortable one-way cab services, providing a direct and convenient ride to Goa."
    },
    {
      "name": "Mumbai to Goa Round Trip",
      "description": "S9 Travels offers round-trip cab services from Mumbai to Goa, providing a flexible and comfortable option for travelers looking to explore Goa and return with ease."
    },
    {
      "name": "Affordable Mumbai to Goa Cab",
      "description": "Looking for an affordable way to travel from Mumbai to Goa? S9 Travels offers cost-effective cab options without compromising on comfort, making it easy to enjoy your trip to Goa."
    },
    {
      "name": "Luxury Cab from Mumbai to Goa",
      "description": "For those seeking a premium travel experience, S9 Travels offers luxury cabs from Mumbai to Goa. Travel in style and comfort with top-class amenities and a professional driver."
    },
    {
      "name": "Goa Trip by Cab from Mumbai",
      "description": "Whether it's a weekend getaway or a long holiday, S9 Travels provides the perfect solution for your Goa trip. Our well-maintained cabs and experienced drivers make the journey from Mumbai to Goa comfortable and enjoyable."
    },
    {
      "name": "Private Cab Hire for Mumbai to Goa",
      "description": "Experience the convenience of a private cab hire for your journey from Mumbai to Goa. S9 Travels provides personalized travel with a private vehicle and professional driver to ensure you have a smooth and relaxed trip."
    },
    {
      "name": "Mumbai to Goa Cab Booking Online",
      "description": "Booking a cab from Mumbai to Goa has never been easier. With S9 Travels, you can book your ride online in just a few simple steps. Choose your preferred time, and we’ll take care of the rest."
    },
    {
      "name": "Group Travel to Goa in Mumbai Taxi",
      "description": "Traveling with a group? S9 Travels offers group travel cabs for your trip to Goa from Mumbai. Enjoy a spacious and comfortable ride for your entire group, making the journey a memorable experience."
    },
    {
      "name": "Mumbai to Goa Sightseeing Cab",
      "description": "Explore Goa with our sightseeing cab service. S9 Travels provides customized sightseeing tours that allow you to visit Goa's top attractions, with a professional driver who knows the best routes."
    },
    {
      "name": "Goa Holiday by Private Taxi",
      "description": "Make your Goa holiday special with a private taxi from Mumbai. S9 Travels provides personalized services that cater to your needs, ensuring you have a relaxing and comfortable journey to Goa."
    },
    {
      "name": "Comfortable Mumbai to Goa Travel",
      "description": "S9 Travels ensures a comfortable and stress-free travel experience from Mumbai to Goa. Our fleet of well-maintained vehicles and experienced drivers will make sure your journey is both safe and enjoyable."
    }
],

"tableData": [
  ["Mumbai to Goa Cab Service", "Book Mumbai to Goa Taxi"],
  ["Mumbai to Goa One-Way Cab", "Mumbai to Goa Round Trip"],
  ["Affordable Mumbai to Goa Cab", "Luxury Cab from Mumbai to Goa"],
  ["Goa Trip by Cab from Mumbai", "Private Cab Hire for Mumbai to Goa"],
  ["Mumbai to Goa Cab Booking Online", "Group Travel to Goa in Mumbai Taxi"],
  ["Mumbai to Goa Sightseeing Cab", "Goa Holiday by Private Taxi"],
  ["Comfortable Mumbai to Goa Travel", ""]
],




"whychoose": [
  {
    "WhyChooseheading": "Comfortable and Relaxing Long-Distance Travel",
    "WhyChoosedescription": "S9 Travels offers a comfortable and relaxing Mumbai to Goa cab service. Our spacious and well-maintained vehicles, including the Toyota Innova, ensure a smooth and comfortable ride as you travel from Mumbai to Goa, allowing you to enjoy your journey without any stress."
  },
  {
    "WhyChooseheading": "Timely and Reliable Service",
    "WhyChoosedescription": "Whether you're planning a vacation or business trip, our Mumbai to Goa cab service ensures reliable and punctual service. Our professional drivers prioritize timely pick-ups and drop-offs, ensuring you make the most of your trip and arrive in Goa without any delays."
  },
  {
    "WhyChooseheading": "Experienced Drivers for a Smooth Journey",
    "WhyChoosedescription": "Our drivers are experienced and familiar with the route from Mumbai to Goa, ensuring a smooth and efficient journey. With knowledge of the best routes and traffic patterns, they guarantee a safe and comfortable drive, letting you relax during the long-distance travel."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers competitive and transparent pricing for your Mumbai to Goa cab service. We provide clear cost breakdowns during the booking process, with no hidden charges, so you can easily plan your travel budget."
  },
  {
    "WhyChooseheading": "Safety and Comfort on the Road",
    "WhyChoosedescription": "Safety is our priority. Our cabs are equipped with modern safety features such as GPS tracking, airbags, and seat belts, so you can travel with peace of mind from Mumbai to Goa. Additionally, our vehicles are maintained to the highest standards of comfort and cleanliness."
  },
  {
    "WhyChooseheading": "24/7 Availability for Flexible Travel",
    "WhyChoosedescription": "S9 Travels operates 24/7, offering flexible booking options for your Mumbai to Goa journey. Whether you're traveling during the day or prefer a late-night ride, we ensure our cab service is always available to suit your schedule."
  },
  {
    "WhyChooseheading": "Customizable Travel Plans for Your Goa Trip",
    "WhyChoosedescription": "We understand that every trip is unique. Whether you’re planning a relaxed holiday or have specific stops in mind, we offer customizable travel plans for your Mumbai to Goa journey. We can adjust pick-up locations, stops along the way, and other details to match your preferences."
  },
  {
    "WhyChooseheading": "Seamless Booking Process",
    "WhyChoosedescription": "Booking a Mumbai to Goa cab with S9 Travels is easy and convenient. You can book your ride online through our website or app, or contact our customer service team for personalized assistance. We ensure a smooth and hassle-free booking experience."
  }
]











    }



    const faqData = [
        [
          {
            question: 'How can I book a cab from Mumbai to Goa with S9 Travels?',
            answer: 'Booking a cab from Mumbai to Goa is easy! You can book your ride through our website or app, or contact our customer service team for personalized assistance to arrange your trip comfortably.',
          },
          {
            question: 'What types of vehicles are available for Mumbai to Goa travel?',
            answer: 'We offer a variety of vehicles for your Mumbai to Goa journey, including sedans, SUVs, and premium vehicles like the Toyota Innova. Choose the one that fits your group size and travel preferences for a comfortable and smooth ride.',
          },
          {
            question: 'How long does the journey from Mumbai to Goa take?',
            answer: 'The journey from Mumbai to Goa typically takes around 10 to 12 hours, depending on the traffic and road conditions. Our experienced drivers ensure a safe and timely arrival, making your long-distance trip as comfortable as possible.',
          },
          {
            question: 'Are the drivers experienced for long-distance travel like Mumbai to Goa?',
            answer: 'Yes, all our drivers are highly experienced in long-distance travel and familiar with the Mumbai to Goa route. They ensure your journey is safe, smooth, and comfortable, adhering to the best travel practices.',
          },
          {
            question: 'Can I book a round trip for Mumbai to Goa?',
            answer: 'Yes, we offer round-trip bookings for your Mumbai to Goa travel. You can plan your return trip at your convenience, and we will ensure a comfortable and timely journey back to Mumbai after your stay in Goa.',
          },
          {
            question: 'Is there a fixed fare for Mumbai to Goa cab service?',
            answer: 'Our pricing for Mumbai to Goa cab services is flexible based on the type of vehicle, duration, and specific requirements of your trip. Contact us to get a customized quote based on your travel needs.',
          },
          {
            question: 'Do you provide pickup from Mumbai airport or hotels for Goa trips?',
            answer: 'Yes, we provide convenient pickup services from Mumbai airport or your hotel for your trip to Goa. Our drivers will ensure a seamless transfer, making your journey to Goa stress-free and comfortable.',
          },
          {
            question: 'Can I request additional stops on the way to Goa?',
            answer: 'Yes, if you wish to make stops for sightseeing or breaks during the trip to Goa, simply inform us while booking. We will customize the trip to include your preferred stops along the way.',
          },
          {
            question: 'Is there any extra charge for waiting or detours during the Mumbai to Goa trip?',
            answer: 'Any extra charges for waiting or detours will be communicated upfront when booking. We ensure full transparency in pricing so that there are no surprises during your trip.',
          },
          {
            question: 'Why should I choose S9 Travels for my Mumbai to Goa cab service?',
            answer: 'S9 Travels offers a reliable, safe, and comfortable cab service for long-distance journeys like Mumbai to Goa. With experienced drivers, well-maintained vehicles, and excellent customer service, we ensure a smooth and enjoyable trip.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Amit Mehta',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“Our trip from Mumbai to Goa with S9 Travels was fantastic! The driver was professional, and the vehicle was comfortable for the long journey. The ride was smooth, and we reached Goa on time. I would highly recommend S9 Travels for long-distance trips.”',
        },
        {
          name: 'Mrs. Rina Shah',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I booked a Mumbai to Goa cab with S9 Travels, and it was a great experience. The driver was very courteous and familiar with the route. The entire trip was hassle-free, and we had a comfortable journey. I would definitely book with them again!”',
        },
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   

      
    const productSchema = {
      "@context": "https://schema.org",
      "@type": "Product",
      "name": "Mumbai to Goa Cabs",
      "description": "Book affordable and reliable Mumbai to Goa cab services. S9 Travels offers one-way, round-trip, luxury cabs, and group transport options for your Goa trip. Enjoy a comfortable and hassle-free ride from Mumbai to Goa with our experienced drivers. Perfect for holidays, sightseeing tours, and corporate travel.",
      "aggregateRating": {
        "@type": "AggregateRating",
        "bestRating": "5",
        "worstRating": "1",
        "ratingValue": "4.9",
        "ratingCount": "7425"
      }
    };
    

    

    return (
        <div>
        
 
        <Helmet>
      <title>Mumbai to Goa Cab | Affordable & Luxury Cabs | S9 Travels</title>
      <meta 
        name="description" 
        content="Book Mumbai to Goa cabs with S9 Travels. Choose from one-way, round-trip, luxury cabs, or group transport options. Enjoy affordable, safe, and comfortable travel for your Goa holiday or sightseeing tours. Contact S9 Travels at +91 8850328441." 
      />
      
      {/* Inject JSON-LD Schema */}
      <script type="application/ld+json">
        {JSON.stringify(productSchema)}
      </script>
    </Helmet>
      

<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/50.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaitogoacab;